export default __webpack_public_path__ + "static/media/payment.765d2282.jpg";